import {
  RECEIVE_ORDERS,
  REQUEST_ORDERS
} from 'constants/reduxActions';
import { injectUniqueIdsToLineItems } from 'helpers/MyAccountUtils';
import { Order } from 'types/mafia';
import { AppAction } from 'types/app';

export interface OrdersState {
  orders: Order[] | null;
  totalPages: number | null;
  isLoading: boolean;
}

const initialState: OrdersState = {
  orders: null,
  totalPages: null,
  isLoading: false
};

export default function orders(state = initialState, action: AppAction): OrdersState {
  switch (action.type) {
    case REQUEST_ORDERS:
      return { ...state, isLoading: true };

    case RECEIVE_ORDERS:
      const { orders, totalPages } = action;
      const newOrders = orders.map(order => ({
        ...order,
        lineItems: injectUniqueIdsToLineItems(order)
      }));
      return { ...state, totalPages, orders: newOrders, isLoading: false };

    default:
      return state;
  }
}
